<form
  class="form"
  [formGroup]="noteChangePriceFormGroup()"
>
  @for (row of noteChangePriceRows; track $index) {
    @if (getFormFields(row.key).length) {
      <div
        class="form-row"
        [class]="getRowClass(row.key)"
      >
        @if (row.key !== 'comment') {
          <div class="row-title">
            {{ row.label }}
          </div>
        }
        @for (field of getFormFields(row.key); track $index) {
          @switch (field.type) {
            @case ('textarea') {
              <mat-form-field
                appearance="outline"
                class="form-textarea"
                [class]="getClassField(field)"
              >
                <mat-label>{{ getFieldLabel(field) }}</mat-label>
                <textarea
                  matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="3"
                  cdkAutosizeMaxRows="3"
                  [formControlName]="field.fieldName"
                  (blur)="handleUpdateField(field.fieldName)"
                ></textarea>
              </mat-form-field>
            }
            @default {
              <mat-form-field
                appearance="outline"
                class="form-field"
                [class]="getClassField(field)"
              >
                <mat-label>{{ getFieldLabel(field) }}</mat-label>
                <input
                  matInput
                  class="form-field-input"
                  [type]="field.type"
                  [formControlName]="field.fieldName"
                  (blur)="handleUpdateField(field.fieldName)"
                >
                @if (field.needMatTextSuffix) {
                  <span matTextSuffix>
                    {{ field.matTextSuffix }}
                  </span>
                }
              </mat-form-field>
            }
          }
        }
      </div>
    }
  }
</form>
